import {
  ContactFormLeadAction,
  InteractionContainerDetail,
  InteractionElement,
  InteractionEvent,
  InteractionGoal,
} from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';

export function trackContactFormExpanded(
  interactionContainerDetail: InteractionContainerDetail,
): void {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: InteractionGoal.OPEN_CONTACT_FORM_AGAIN,
    h_event_label_008: interactionContainerDetail,
  });
}

export enum PhoneNumberType {
  LISTER_PHONE = 'listerContactPhone_lister-phone',
  LISTER_MOBILE = 'listerContactPhone_lister-mobile',
  VIEWING_PHONE = 'viewingContactPhone_viewing-phone',
}

export enum ContactActionType {
  REVEAL_NUMBER_LISTER = 'revealNumberLister',
  REVEAL_NUMBER_VIEWING = 'revealNumberViewing',
  CALL_LISTER = 'callLister',
  CALL_VIEWING = 'callViewing',
}

export function trackContactCallLead(
  numberType: PhoneNumberType,
  contactActionType: ContactActionType,
): void {
  trackEventHarmonized(InteractionEvent.SUBMIT_CALLED, {
    h_event_category_006: InteractionGoal.CTA_CLICK_LEAD_CALL,
    h_event_action_007: numberType,
    h_event_label_008: contactActionType,
  });
}

export function trackContactFormLead(
  action: ContactFormLeadAction,
  contactInquiryId: string | undefined,
  isLeadOfferSale: boolean,
  leadsStatus: 'verified' | 'not_verified',
  hasExtraInformation = false,
  isFormSubmittedwithProfileId?: boolean,
  conversionSource?: string,
): void {
  trackEventHarmonized(InteractionEvent.SUBMIT_FORM_LEAD, {
    h_event_category_006: InteractionEvent.FORM_SYSTEM_FEEDBACK_LEAD,
    h_event_action_007: action,
    h_event_label_008: InteractionGoal.SEND_MESSAGE_OK,
    h_lead_id_066: contactInquiryId,
    h_lead_offer_sale_138: isLeadOfferSale,
    h_extra_information_144: hasExtraInformation,
    h_share_user_profile_145: isFormSubmittedwithProfileId,
    h_lead_status_067: leadsStatus,
    ...(conversionSource && { h_conversion_source_061: conversionSource }),
  });
}

export function trackContactFormLeadError(action: ContactFormLeadAction): void {
  trackEventHarmonized(InteractionEvent.SUBMIT_FORM_LEAD_ERROR, {
    h_event_category_006: InteractionElement.FORM_SUBMIT_BUTTON,
    h_event_action_007: action,
    h_event_label_008: InteractionGoal.SEND_MESSAGE_ERROR,
  });
}

export function getContactFormLeadAction(isFormWithAddress: boolean): ContactFormLeadAction {
  return isFormWithAddress
    ? ContactFormLeadAction.WITH_ADDRESS
    : ContactFormLeadAction.WITHOUT_ADDRESS;
}

export function trackContactFormModalClose(listingId: string): void {
  trackEventHarmonized(InteractionEvent.FAVOURITES_INTERACTION, {
    h_event_action_007: 'close_formlead_modal',
    h_event_label_008: listingId,
    h_listing_advertisement_id_120: listingId,
  });
}

export function trackContactFormProfilePreviewClick(): void {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_action_007: 'preview_profile',
    h_event_label_008: undefined,
  });
}
